import { renderEyebrowBlock } from '../render/blocks/eyebrow';
import { EyebrowBlockSettings } from '../settings/blocks/eyebrow';
import { defineBlockRegistryEntry } from './defineEntry';
import { eyebrowBlockDefinition } from '../domain/blocks/eyebrow';

export const eyebrowBlockRegistryEntry = defineBlockRegistryEntry(
  eyebrowBlockDefinition,
  renderEyebrowBlock,
  EyebrowBlockSettings,
);
